import React, { useContext, useEffect, useState } from 'react'
import { Context } from './Context'
import axios from 'axios'
import { brochureRequestData, QuoteData } from '../wbstdt/Wbstdt'
import LoadingScreen from './LoadingScreen'

export default function RequestCat(props) {

    const { lang } = useContext(Context)
    const [selectedCat, setSelectedCat] = useState(brochureRequestData[lang].options[0])
    const [selectedCatIndex, setSelectedCatIndex] = useState(0)
    const [code, setCode] = useState(QuoteData[lang].tab4[0].code)
    const [country, setCountry] = useState(QuoteData[lang].tab4[0].country)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [number, setNumber] = useState('')
    const [company, setCompany] = useState('')
    const [wbst, setWbst] = useState('')
    const [isFormEmpty, setIsFormEmpty] = useState(true)
    const [loadingScreen, setLoadingScreen] = useState(false)

    useEffect(() => {
        if (!name || !email || !company || !number)
            setIsFormEmpty(true)
        else
            setIsFormEmpty(false)

    }, [name, email, company, number])

    const setRegion = (e) => {
        let countryCode = QuoteData[lang].tab4.filter(item => item.country === e.target.value)
        setCountry(countryCode[0].country)
        setCode(countryCode[0].code)
    }

    const hideMe = () => {
        props.onClick()
    }

    const sendForm = (e) => {
        e.preventDefault()
        let data = {
            catID: selectedCatIndex,
            name,
            email,
            country: country,
            number: `${code} ${number}`,
            cat: selectedCat.title,
            company,
            website: wbst,
        }

        setLoadingScreen(true)

        axios.post('/request-cat', { data})
            .then(data => {
                window.location = data.data
            }).catch(err => {
                setLoadingScreen(false)
                console.log(err)
            })
    }

    return (
        <div id="rq-br" className="flex-container-centered fadeout">
            <div id="rq-br-full-form" className="box-wsp slidedown">
                <span onClick={hideMe}>&#10005;</span>
                <h3 className="title container">{brochureRequestData[lang].title}</h3>
                <form className="container box-wsp" onSubmit={sendForm}>
                    <div className="flex-container-scattered">
                        <div className="input-fields">
                            <select className="if ifs-full .ifs-small-mobile" onChange={(e) => { setSelectedCat(brochureRequestData[lang].options[e.target.value]); setSelectedCatIndex(e.target.value);}}>
                                {brochureRequestData[lang].options.map((item, index) => {
                                    return (
                                        <option key={index} value={index}>{item.title}</option>
                                    )
                                })}
                            </select>
                            <input className="if ifs-full .ifs-small-mobile" type="text" placeholder={brochureRequestData[lang].tab1} value={name} onChange={(e) => setName(e.target.value)} required />
                            <input className="if ifs-full" type="email" placeholder={brochureRequestData[lang].tab2} value={email} onChange={(e) => setEmail(e.target.value)} required />
                            <select className="if ifs-full" value={country} onChange={setRegion}>
                                {QuoteData[lang].tab4.map((item, index) => {
                                    return (
                                        <option key={index} value={item.country}>{item.country}</option>
                                    )
                                })}
                            </select>
                            <div className="tel-if tel-ifs-full">
                                <label htmlFor="tel">{code}</label>
                                <input type="tel" className="ifs-full" name="" id="tel" placeholder={brochureRequestData[lang].tab3} value={number} onChange={(e) => setNumber(e.target.value)} pattern="^[+]*[0-9]{8,15}$" required />
                            </div>
                            <input className="if ifs-full" type="text" placeholder={brochureRequestData[lang].tab4} value={company} onChange={(e) => setCompany(e.target.value)} required />
                            <input className="if ifs-full" type="text" placeholder={brochureRequestData[lang].tab5} value={wbst} onChange={(e) => setWbst(e.target.value)} />
                        </div>
                        <div className="showcase if flex-container-centered">
                            <div>
                                <img src={selectedCat.img} alt={selectedCat.title} />
                                <h4 style={{ marginBottom: 0 }}>{selectedCat.title}</h4>
                            </div>
                        </div>
                    </div>
                    <button className={`btn btn-full ${!isFormEmpty ? "btn-normal-enabled" : "btn-normal-disabled"}`} disabled={isFormEmpty}>{brochureRequestData[lang].btn}</button>
                </form>
            </div>
            {loadingScreen && <LoadingScreen />}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Component/RequestCat.js